import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnInit,
} from "@angular/core";

@Component({
  selector: "app-no-key-account-selected",
  templateUrl: "./no-key-account-selected.component.html",
  styleUrl: "./no-key-account-selected.component.scss",
})
export class NoKeyAccountSelectedComponent implements OnInit {
  @Input() keyAccountPlaceholderObject: any;
  @Output() keyAccountSelectEmit = new EventEmitter<any>();

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes["keyAccountPlaceholderObject"]) {
      const currentValue = changes["keyAccountPlaceholderObject"].currentValue;

      if (currentValue) {
        this.keyAccountPlaceholderObject = currentValue;
      }
    }
  }
}
